
export const StorageNS = {
	PREFERENCES: 'sync-user-preferences'
};

export const Preferences = {
	TEMP_UNIT: 'temp-unit'
};

export const Errors = {
	NO_ALERT_DETAILS_FOUND: 901,
	NO_DETAIL_KEY_FOUND: 901
};
